import i18n from '@/locales/i18n.ts'

export interface GeocodeResult {
    latitude: number
    longitude: number
}

export const geocodeAddress = async (query: string): Promise<GeocodeResult> => {
    const trimmedQuery = query.trim()

    if (!trimmedQuery) {
        throw new Error(i18n.t('geocode.error.emptyAddress'))
    }

    if (!window.google?.maps?.Geocoder) {
        throw new Error(i18n.t('geocode.error.sdkNotReady'))
    }

    const geocoder = new window.google.maps.Geocoder()
    const { results } = await geocoder.geocode({ address: trimmedQuery, region: 'KR' })
    const location = results?.[0]?.geometry?.location

    if (!location) {
        throw new Error(i18n.t('geocode.error.notFound'))
    }

    const latitude = location.lat()
    const longitude = location.lng()

    if (!Number.isFinite(latitude) || !Number.isFinite(longitude)) {
        throw new Error(i18n.t('geocode.error.invalidCoordinate'))
    }

    return { latitude, longitude }
}
